import { c as _c } from "react/compiler-runtime";
import { fillVariants } from "../../../styles/utils/fill";
export const AvalancheLogo = t0 => {
  const $ = _c(18);
  let className;
  let rest;
  let t1;
  let t2;
  let t3;
  if ($[0] !== t0) {
    ({
      className,
      fill: t1,
      fillAttribute: t2,
      size: t3,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = className;
    $[2] = rest;
    $[3] = t1;
    $[4] = t2;
    $[5] = t3;
  } else {
    className = $[1];
    rest = $[2];
    t1 = $[3];
    t2 = $[4];
    t3 = $[5];
  }
  const fill = t1 === undefined ? "current" : t1;
  const fillAttribute = t2 === undefined ? "currentColor" : t2;
  const size = t3 === undefined ? 24 : t3;
  let t4;
  if ($[6] !== size) {
    t4 = {
      width: size,
      height: size
    };
    $[6] = size;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  let t5;
  if ($[8] !== fill) {
    t5 = fillVariants({
      fill
    });
    $[8] = fill;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== fillAttribute || $[11] !== t5) {
    t6 = <path className={t5} d="M18.636 14.085c.29-.148.633-.148.924 0 .264.134.47.482.876 1.17l.033.056 2.897 4.955.042.072.096.166.167.294c.227.405.34.659.328.878-.015.326-.189.628-.465.807-.213.14-.546.163-1.145.167h-6.567c-.599-.004-.932-.026-1.14-.162a1.035 1.035 0 0 1-.465-.807c-.015-.3.196-.664.618-1.393l.01-.017 2.886-4.955c.424-.73.639-1.093.905-1.231ZM12.416 1.46c.272.138.486.51.91 1.257l2.048 3.575.01.019c.459.8.691 1.206.792 1.631.113.465.113.956 0 1.42-.102.43-.332.838-.796 1.65l-5.234 9.252-.014.024c-.46.807-.694 1.216-1.018 1.524a3.047 3.047 0 0 1-1.241.72c-.354.098-.743.115-1.412.117H1.598c-.593-.004-.92-.026-1.132-.162A1.026 1.026 0 0 1 0 21.686c-.016-.302.194-.67.613-1.405l9.964-17.563c.424-.746.638-1.119.91-1.257.29-.148.638-.148.929 0Z" fill={fillAttribute} />;
    $[10] = fillAttribute;
    $[11] = t5;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  let t7;
  if ($[13] !== className || $[14] !== rest || $[15] !== t4 || $[16] !== t6) {
    t7 = <svg className={className} style={t4} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" {...rest}>{t6}</svg>;
    $[13] = className;
    $[14] = rest;
    $[15] = t4;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  return t7;
};